import React, { useEffect, useState } from "react";
import Hero from "@/components/sections/Hero";
import LeadWizard from "@/components/sections/LeadWizard";
import CarrierBanner from "@/components/sections/CarrierBanner";
import CoverageCards from "@/components/sections/CoverageCards";
import JarvisStrip from "@/components/sections/JarvisStrip";
import RecruitingStrip from "@/components/sections/RecruitingStrip";
import Testimonials from "@/components/sections/Testimonials";
import LatestPosts from "@/components/sections/LatestPosts";
import SEO from "@/components/SEO";
import { fetchSettings } from "@/lib/api";

const PUBLIC_URL = "https://mmalifeusa.com";

const ORG_JSONLD = {
    "@context": "https://schema.org",
    "@type": "InsuranceAgency",
    name: "Moving Mountains Advisors",
    alternateName: "Moving Mountains Inc.",
    url: PUBLIC_URL,
    logo: `${PUBLIC_URL}/brand/logo.png`,
    image: `${PUBLIC_URL}/brand/logo.png`,
    telephone: "+1-813-739-9877",
    description:
        "Independent insurance advisory firm serving Florida and nationwide where licensed. Life, health, retirement, and estate protection — AI-assisted, human-reviewed.",
    areaServed: {
        "@type": "State",
        name: "Florida",
    },
    sameAs: ["https://instagram.com/mmalifeusa"],
    founder: {
        "@type": "Person",
        name: "Jeremy Felix",
        jobTitle: "Founder & CEO",
    },
};

export default function Home() {
    const [settings, setSettings] = useState(null);
    useEffect(() => {
        fetchSettings().then(setSettings).catch(() => {});
    }, []);
    return (
        <div data-testid="home-page">
            <SEO
                title="Moving Mountains Advisors — Protection that moves with you."
                description="Personalized life, health, and retirement guidance — no pressure, no guesswork. AI-assisted, human-reviewed."
                ogImage={`${PUBLIC_URL}/brand/og-default.png`}
                jsonLd={ORG_JSONLD}
            />
            <Hero settings={settings} />
            <CarrierBanner />
            <CoverageCards />
            <LeadWizard />
            <JarvisStrip />
            <RecruitingStrip />
            <Testimonials />
            <LatestPosts />
        </div>
    );
}
